import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { NewRatingPage } from "../newRating/newRating";
import { Events } from "ionic-angular";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { WhiskyDB } from "../../data/db";

@Component({
  selector: "page-ratings",
  templateUrl: "ratings.html"
})
export class RatingsPage {
  newRatingPage: any;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    private alertCtrl: AlertController
  ) {
    this.initializeItems();
    this.newRatingPage = NewRatingPage;

    // Update event
    this.events.subscribe("ratings:updated", () => {
      console.log("Got ratings:updated event");

      // Reapply fiters
      if (this.lastFilter == null) {
        this.items = WhiskyDB.ratings;
      } else {
        this.getItems(this.lastFilter);
      }
    });

    this.events.subscribe("ratings:save", () => {
      WhiskyDB.db.saveRatings();
    });

    this.events.subscribe("ratings:add", item => {
      console.log("Got ratings:add event" + item);
      WhiskyDB.ratings.push(item);
      this.events.publish("ratings:save");
      this.events.publish("ratings:updated");
    });
  }

  searchQuery: string = "";
  items: any[];
  lastFilter: any = null;

  initializeItems() {
    // Initial list is unfiltered
    this.items = WhiskyDB.ratings;
  }

  getItems(ev: any) {
    // Sve the filter
    this.lastFilter = ev;

    // Reset items back to all of the items
    this.items = WhiskyDB.ratings;

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      console.log("Filter=" + val);
      this.items = WhiskyDB.ratings.filter(item => {
        return item.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
  }

  remove(toRemove: any, slider: any) {
    slider.close();
    let alert = this.alertCtrl.create({
      title: "Remove Rating?",
      subTitle: toRemove,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove);
            // Remove is via a filter
            WhiskyDB.ratings = WhiskyDB.ratings.filter(item => {
              return item != toRemove;
            });

            // Save them
            this.events.publish("ratings:save");
            this.events.publish("ratings:updated");
          }
        }
      ]
    });
    alert.present();
  }

  editItem(item, slider) {
    slider.close();
    let prompt = this.alertCtrl.create({
      title: "Edit Shelf",
      inputs: [
        {
          name: "Rating",
          value: item,
        }
      ],
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Save",
          handler: data => {
            let index = this.items.indexOf(item);

            if (index > -1) {
              this.items[index] = data.Rating;
              console.log("Old: " + item + " new: " + data.Rating);
              WhiskyDB.ratings[index] = data.Rating;
              WhiskyDB.db.saveShelves();

              WhiskyDB.whisky.forEach(w => {
                if(w.rating === item)
                  w.rating = data.Rating;
              });

              WhiskyDB.db.saveWhisky();
              this.events.publish("ratings:updated");

            }
          }
        }
      ]
    });

    prompt.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ratings/ratings.ts